import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

interface PerformanceMetricsProps {
  performanceData: {
    hoursWorked: number
    acceptanceRate: number
    commissionPerRide: number
    ridesPerHour: number
  }
}

export default function PerformanceMetrics({
  performanceData,
}: PerformanceMetricsProps) {
  const hoursWorked = performanceData.hoursWorked

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Métricas de Performance</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <div className="flex justify-between">
            <span className="text-sm text-muted-foreground">
              Horas Trabalhadas:
            </span>
            <span className="font-medium">{hoursWorked.toFixed(2)}h</span>
          </div>
          <div className="flex justify-between">
            <span className="text-sm text-muted-foreground">
              Comissão Média por Corrida:
            </span>
            <span className="font-medium">
              R$ {performanceData.commissionPerRide.toFixed(2)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-sm text-muted-foreground">
              Corridas por Hora:
            </span>
            <span className="font-medium">
              {performanceData.ridesPerHour.toFixed(1) || 0}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
